export enum FindAgentByLoginEmailResultType {
  notFound = 'notFound',
  found = 'found',
  conflict = 'conflict',
}

export type FindAgentByLoginEmailResult =
  | { resultType: FindAgentByLoginEmailResultType.notFound }
  | { resultType: FindAgentByLoginEmailResultType.found; agentDbId: string }
  | { resultType: FindAgentByLoginEmailResultType.conflict; agentDbIds: string[] };

